<template>
  <section class="ProductDescription">
    <div class="ProductDescription-text" v-if="productDescription">
      <Richtext :text="productDescription"></Richtext>
    </div>
  </section>
</template>

<script>
import Richtext from "@/components/Richtext/Richtext.vue";
import { mapGetters } from "vuex";

import "@/components/Product/ProductDescription/ProductDescription.scss";

export default {
  name: "ProductDescription",
  components: { Richtext },
  computed: {
    ...mapGetters({ productDescription: "getProductDescription" }),
  },
};
</script>
